import * as React from 'react';
import * as moment from 'moment';
import { TrackersData } from 'data/TrackersData';
import { observer } from 'mobx-react';

import './GraphNav.pcss';

const GraphNav = observer(() =>
  <div className="graphNav">
    <button onClick={TrackersData.subtractWeekFromWeeklyMoment} className={`${TrackersData.weeklyMomentIsFirstPortalMoment ? 'disabled':''}`}><i className="fa fa-chevron-left"></i></button>
    <div className="status">
      {TrackersData.weeklyMomentIsThisWeek ? 'This Week' : `${TrackersData.weeklyMoment.format('M/D')}–${moment(TrackersData.weeklyMoment).add(6, 'd').format('M/D')}`}
    </div>
    <button onClick={TrackersData.addWeekToWeeklyMoment} className={`${TrackersData.weeklyMomentIsThisWeek ? 'disabled':''}`}><i className="fa fa-chevron-right"></i></button>              
  </div>
);

export { GraphNav };